import {User} from '../../models/user';
import {BijbError} from '../../models/bijb-error';
import {LoadableState} from './loadable-state';
import {autoserializeAs, inheritSerialization} from 'cerialize';
import {BijbAccount} from '../../models/bijb-account';

@inheritSerialization(LoadableState)
export class CurrentAccountState extends LoadableState {
  public static readonly key = 'CurrentAccountState';

  @autoserializeAs(BijbAccount, 'user')
  public account: BijbAccount = null;

  @autoserializeAs(BijbError, 'error')
  public error: BijbError;
}
